import SearchLookup from '@bbc/news-vj-search-lookup';
import { clear, text } from '@bbc/news-vj-search-lookup-helpers/DOMHelper';

export default class SearchLookupOverride extends SearchLookup {
    render() {
        const {
            menuShouldOpen,
            focusIndex,
            suggestions,
            query,
            shouldDisplayError,
        } = this.state;

        this.els.wrapper.setAttribute('aria-expanded', menuShouldOpen);

        // Update Input
        const optionFocusId = `${this.id}__option--${focusIndex}`;
        const optionFocused = focusIndex !== -1;
        if (optionFocused) {
            this.els.input.setAttribute('aria-activedescendant', optionFocusId);
            this.els.input.value = suggestions[focusIndex].data[this.displayKey];
        } else {
            this.els.input.value = query;
            this.els.input.removeAttribute('aria-activedescendant');
        }

        // Update Button
        this.state.indexOfMatchingElement = this.getIndexOfMatchingElement();

        if (this.useSuggestions) {
            if (this.hasButton) {
                const hasExactMatch = this.state.indexOfMatchingElement >= 0;
                const willSubmitOnBlur = this.confirmOnBlur && suggestions.length > 0;
                const shouldEnableButton = optionFocused ||
                    willSubmitOnBlur ||
                    hasExactMatch;
                if (shouldEnableButton) {
                    this.els.button.removeAttribute('disabled');
                } else {
                    this.els.button.setAttribute('disabled', true);
                }
                this.els.button.classList.remove('news-vj-search-lookup__button--loading');
            }

            // Update Menu Suggestions
            const menuClassModifier = menuShouldOpen ? 'visible' : 'hidden';
            this.els.menu.setAttribute(
                'class',
                `${this.menuClassList} news-vj-search-lookup__menu--${menuClassModifier}`,
            );

            clear(this.els.menu);

            // Update screen reader announcement
            clear(this.els.status);
            const statusText = text(this.stripHtml(this.setStatus(menuClassModifier)));
            this.els.status.appendChild(statusText);

            const suggestionList = suggestions
                .map(
                    (suggestion, i) => (focusIndex === i ?
                    this.createSuggestion(suggestion.data[this.displayKey], i, 'focused') :
                    this.createSuggestion(suggestion.data[this.displayKey], i)),
                )
                .map((suggestion, i) => this.addSuggestionListener('mousedown', suggestion, i));

            if (shouldDisplayError) {
                suggestionList.push(this.createSuggestion(this.errorMessage, 0, 'error-message'));
                if (this.noResultsCallback) suggestionList[0].addEventListener('mousedown', this.noResultsCallback);
            }

            suggestionList.forEach(suggestion => {
                this.els.menu.appendChild(suggestion);
            });
            if (suggestionList.length === 1) {
                this.els.button.removeAttribute('disabled');
            }
        }

        this.els.menu.scrollTop = 0;
        this.pluginManager.postRender(this.els);
    }
}
